<template>
  <div class="tolist-block">
    <van-loading
      type="spinner"
      v-show="pageConfig.showLoadding"
      color="#1989fa"
    />
        <div class="wrapper">
          <van-pull-refresh
            v-model="pageConfig.loading"
            @refresh="pageEvent.AssistantpullDownRefresh()"
            success-text="刷新成功"
            loading-text="加载中"
          >
            <van-empty
              v-if="AssistantList.length == 0"
              description="未找到任何数据"
            />
            <section
              v-for="item in AssistantList"
              @click="pageEvent.openRecord(item)"
              :key="item.id"
            >
              <van-swipe-cell>
                <van-cell
                  :border="false"
                  :title="item.session_name"
                  style="padding: 10px 0px; display: flex; align-items: center"
                >
                  <template #icon>
                    <img v-if="item.file_id==null"  src="@/assets/default-chat.png"  height="30" width="30" alt="" style="margin-right: 10px;" />
                    <img  :src="'/oa_portal/oa/portal/Common/DownloadFile/'+item.file_id+'?tenant_id='+item.tenant_id"  height="30" width="30" alt="" style="margin-right: 10px;" />
                  </template>
                  <template #value>
                    <div style="margin-left: auto; color: #999; font-size: 9px">
                      {{ methods.convertTime(item.max_time) }}
                    </div>
                  </template>
                </van-cell>
                <template #right>
                  <van-button
                    square
                    type="danger"
                    text="删除"
                    @click="pageEvent.deleteAssistant(item)"
                  />
                </template>
              </van-swipe-cell>
            </section>
            <p style="text-align: center" v-show="pageConfig.showLoadMore">
              正在加载...
            </p>
            <p
              style="text-align: center"
              v-show="pageConfig.showNoMore && AssistantList.length > 0"
            >
              没有更多数据
            </p>
          </van-pull-refresh>
        </div>
  </div>
</template>
  <script>
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted, reactive } from "vue";
import { GetAssistantSessionPages, DeleteSessionById } from "@/api/Oa/chatGpt";
import { Toast, Dialog, Notify } from "vant";
import moment from "moment";
import ChangeTitle from "@/utils/changeTitle.js";
export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    // 历史列表
    const RecordList = ref([]);

    // 助手列表
    const AssistantList = ref([]);
    //页面配置
    const pageConfig = reactive({
      //数量
      total: 0,
      //页码
      pageIndex: 1,
      //页数量
      pageSize: 10,
      //显示没有更多数据
      showNoMore: false,
      //正在加载
      showLoadMore: false,
      //加载效果
      showLoadding: false,
      //下拉刷新
      loading: false,
      //实例id
      modelId: route.params.modelId,
    });
    //页面事件
    const pageEvent = {

      //下拉刷新
      AssistantpullDownRefresh: function () {
        //重置列表
        AssistantList.value = [];
        //不显示没有更多数据
        pageConfig.showNoMore = false;
        //不显示没有更多数据
        pageConfig.showLoadMore = false;
        //重置页码
        pageConfig.pageIndex = 1;
        methods.loadAssistantList();
      },

      //打开对话页面
      openRecord: function (item) {
        console.log(item.id);
        router.push({
          name: "chatGPT",
          query: {
            sessionId: item.id,
            sessionName: item.session_name,
            modelId: pageConfig.modelId,
          },
        });
      },
      //删除助手
      deleteAssistant: function (item) {
        Dialog.confirm({
          title: "确定删除吗？",
        })
          .then(async () => {
            methods.deleteRecord(item.id);
            AssistantList.value = [];
            methods.loadAssistantList();
          })
          .catch(() => {});
      },
    };
    //内置函数
    const methods = {
      //加载助手列表
      loadAssistantList: function () {
        let param = {
          isAssist: true,
          model_id: pageConfig.modelId,
        };
        pageConfig.showLoadding = true;
        GetAssistantSessionPages(param).then((res) => {
          pageConfig.showLoadding = false;
          pageConfig.loading = false;
          if (res.code !== 200) {
            Notify({ type: "danger", message: res.msg });
            return;
          }
          res.data.forEach((element) => {
            AssistantList.value.push(element);
          });
          pageConfig.total = res.total;
          if (res.data.length < pageConfig.pageSize) {
            pageConfig.showNoMore = true;
            pageConfig.showLoadMore = false;
          }
        });
      },
      //时间转换
      convertTime: function (time) {
        if (time != "" && time != null) {
          return moment(time).format("MM-DD HH:mm");
        }
      },
      //删除记录
      deleteRecord: function (id) {
        DeleteSessionById({ id: id }).then(async (res) => {
          if (res.success) {
            Notify({ type: "success", message: res.msg });
          } else {
            Notify({ type: "warning", message: res.msg });
          }
        });
      },
    };
    onMounted(() => {
      // //待处理列表
      // methods.loadRecordList();
      methods.loadAssistantList();
      ChangeTitle.setTitle("会话列表");
    });
    return {
      methods,
      RecordList,
      AssistantList,
      pageConfig,
      pageEvent,
    };
  },
};
</script>
  <style lang="scss">
@import "@/assets/commit.scss";

.tolist-block {
  position: relative;
  header {
    background-color: #fff;

    .van-search {
      text-align: left;
      display: inline-block;
      width: calc(100% - 50px) !important;
      vertical-align: middle;
    }

    .screen {
      color: #999;
      display: inline-block;
      width: 40px;
      vertical-align: middle;
      --van-button-border-radius: var(--van-border-radius-max);
    }
  }

  .wrapper {
    overflow-y: auto;
    width: 100%;
    min-height: 200px;
    max-height: calc(100vh - 90px);

    section:active {
      background-color: #fafafa;
    }

    section {
      background-color: #fff;
      padding: 10px;
      margin: 10px 5px;
      border-radius: 5px;

      .user-head {
        vertical-align: top;
        width: 60px;
        display: inline-block;

        .user-photo {
          text-align: center;
          line-height: 30px;
          border-radius: 3px;
          width: 30px;
          height: 30px;
          margin: auto;
          color: #fff;
          background-color: #409eff;
        }
      }

      .waitdeal-info {
        text-align: left;
        width: calc(100% - 60px);
        display: inline-block;

        .task-title {
          font-size: 14px;
        }

        .task-info-list {
          margin: 5px 0;

          .task-info {
            color: #999;
            font-size: 12px;
          }
        }
      }

      .submit-div {
        margin-top: 10px;
      }
    }
  }

  .van-loading {
    text-align: center;
    position: absolute;
    z-index: 9999999;
    width: 80px;
    height: 80px;
    line-height: 80px;
    background-color: #fff;
    border-radius: 10px;
    left: calc(50% - 40px);
    top: 25vh;
  }

  .filter-div {
    overflow-y: hidden;
    background-color: #f0f0f0;

    .filter-title {
      background-color: #fff;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      text-align: center;
      margin: 5px 0;
    }

    .filter-block {
      overflow-y: auto;
      background-color: #fff;
      height: calc(60vh - 70px);
      padding: 10px;

      .flow-type-block {
        border-radius: 20px;
        color: #999;
        display: inline-block;
        width: 40%;
        margin: 5px 4%;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid #ccc;
      }

      .active {
        background-color: #409eff;
        border: 1px solid #409eff;
        color: #fff;
      }
    }
  }
}
</style>
  